import { Stack } from '@chakra-ui/react';
import Header from '@components/typography/Header';
import { antlerStyle } from '@constants/styles';

const Container = ({ header, children, ...rest }) => {
  return (
    <Stack minH={antlerStyle.heroHeight} w="100%" alignItems="center">
      <Stack
        w={['calc(100vw - 16px)', 'calc(100vw - 16px)', 500, 500]}
        alignItems="center"
        maxW="500px"
        mx={[4]}
        my={['60px', '80px']}
        px={['32px', '60px']}
        spacing={6}
        borderRadius={20}
        {...rest}
      >
        {header && (
          <Header as="h3" w="100%" textAlign="center">
            {header}
          </Header>
        )}
        {children}
      </Stack>
    </Stack>
  );
};

export default Container;
